import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  // fleet category
  fleetCategory: [],
  isLoadingFleetCategory: false,
  errorFleetCategory: false,
  // fleet type / truck
  fleetType: [],
  isLoadingFleetType: false,
  errorFleetType: false,
  // origin customer
  originCustomer: [],
  isLoadingOriginCustomer: false,
  errorOriginCustomer: false,
  // destination customer
  destinationCustomer: [],
  isLoadingDestinationCustomer: false,
  errorDestinationCustomer: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tms/index.js